import React from "react";
import ProductDetail from "./ProductDetail";
import { products } from "../data/products";

const GenuineInkTonerPage = () => (
  <ProductDetail product={products.genuineInkToner} />
);

export default GenuineInkTonerPage;
